import { API_URL } from "../../../../actions/settings";
import { useEffect, useState } from "react";
import DegreeDaysRegressionTable from "./DegreeDaysRegressionTable";
import NotificationPopUp from "../../../extras/NotificationPopUp";
import useToggle from "../../../../utils/useToggle";
import LoadingOverlay from "../../../extras/LoadingOverlay";

interface Props {
  id?: string | null;
  name?: string;
}

async function getRegressions(id: any,token: string) {
  return fetch(`${API_URL}/buildings/degree_days_coefficients/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        res.json().then((err) => {
          NotificationPopUp("Error", err, "Error Getting Regressions");
        });
      }
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
}

async function saveRegressions(id: any, body: any, token: string) {
  return fetch(`${API_URL}/buildings/degree_days_coefficients/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => {
      if (res.ok) {
        NotificationPopUp(
          "Success",
          "Selected Regression is saved and will be used for future calculations.",
          "Data Saved"
        );
        return res.json();
      } else {
        res.json().then((err) => {
          NotificationPopUp("Error", err, "Error Saving Data");
        });
      }
    })
    .catch((error) => {
      NotificationPopUp("Error", error.message, "Error Saving Data");
    });
}

const DegreeDaysRegression: React.FC<Props> = ({ id, name }) => {
  const [data, setData] = useState<any>(null);
  const [loading, toggleLoading] = useToggle(false);

  const handleSave = async (props:any) => {
    toggleLoading();
    const token = `Token ${(localStorage.getItem("token") || "").slice(
      1,
      -1
    )}`;
    const data = props ? props.row.original : {} 
    await saveRegressions(id,data, token);

    toggleLoading();
  };

  useEffect(()=>{
    const handleRegressions = async () => {
    toggleLoading();
    const token = `Token ${(localStorage.getItem("token") || "").slice(1, -1)}`;
    const res = await getRegressions(id, token);
    if (res) {
      setData({
        "regressions" : res
      });
    }
    toggleLoading();
  };

    if(id !== ''){
      handleRegressions()
    }
    
  },[id,toggleLoading])

  return (
    <div>
      <div style={{ textAlign: "center" }}>
      </div>
      
      <div>
        <DegreeDaysRegressionTable
          name={name}
          data={data}
          handleSave={handleSave}
        />
      </div>

      <LoadingOverlay hidden={!loading}/>
    </div>
  );
};

export default DegreeDaysRegression;
